import {
    Modal,
    ModalContent,
    ModalBody,
    Button,
    Input
} from "@heroui/react";
import { useMediaQuery } from '@custom-react-hooks/use-media-query';
import { useLocation, useSearchParams } from "react-router-dom";
import { Faq } from "./faq2.0";
import { PrivacyPolicy } from "./privacyPolicy";
import { TermsOfService } from "./termsOfService";
import { CommerceDisclosure } from "./commerceDisclosure";
import { AboutUs } from "./aboutUs";

export const LandingPageModal = ({ isOpen, onClose }) => {

    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const activeQuestion = searchParams.get("q");

    return (
        <Modal isOpen={isOpen}
            onOpenChange={(open) => !open && onClose()}
            size={isDesktop ? "2xl" : "2xl"}
            classNames={{
                base: "bg-white/75 !px-0 rounded-t-3xl rounded-b-none lg:rounded-3xl m-0 lg:m-1",
                body: "!px-2",
                header: "!px-2",
                footer: "!px-2",
                backdrop: "bg-black/10 backdrop-saturate-125"
            }}
            placement={isDesktop ? "center" : "bottom"}
            scrollBehavior={!isDesktop && "inside"}
            backdrop="blur"
            hideCloseButton={isDesktop}
            motionProps={{
                variants: {
                    enter: {
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 0.3,
                            ease: "easeOut",
                        },
                    },
                    exit: {
                        y: 15,
                        opacity: 0,
                        transition: {
                            duration: 0.2,
                            ease: "easeIn",
                        },
                    },
                },
            }}
        >
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalBody className="w-full flex gap-2 overflow-y-hidden">
                            {location.pathname === "/faq" && <Faq id={activeQuestion}/>}
                            {location.pathname === "/privacy-policy" && <PrivacyPolicy/>}
                            {location.pathname === "/terms-of-service" && <TermsOfService/>}
                            {location.pathname === "/commerce-disclosure" && <CommerceDisclosure/>}
                            {location.pathname === "/about-us" && <AboutUs/>}
                        </ModalBody>
                    </>
                )}
            </ModalContent>

        </Modal>
    )
}